import type { SVGProps } from 'react'
const SvgShoppingCartOff = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="shopping-cart-off_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#shopping-cart-off_svg__a)">
      <path d="M11.968 9.737 10.333 8.11h1.32L13.6 4.567H6.79L5.15 2.933h9.682q.557 0 .819.42.261.418-.022.948l-2.56 4.626a1.7 1.7 0 0 1-.518.579q-.312.213-.583.23m-6.718 6.83q-.618 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.441-.44 1.06-.44.62 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06t-1.06.44m10.215 1.092-4.88-4.842H5.62q-.868 0-1.323-.741-.453-.741-.052-1.541l.814-1.622-1.35-3.001L.431 2.625l1.095-1.1 15.038 15.039zm-6.518-6.476L7.518 9.75H6.46l-.723 1.433zm3.803 5.384q-.619 0-1.06-.44a1.44 1.44 0 0 1-.44-1.06q0-.618.44-1.06.441-.44 1.06-.44.62 0 1.06.44.44.442.44 1.06 0 .62-.44 1.06t-1.06.44" />
    </g>
  </svg>
)
export default SvgShoppingCartOff
